import PublicOfferPage from './public-offer-page'

export default PublicOfferPage
